import initialState from "./initialState";

export function UserSearchReducer(
  state = initialState.UserSearchReducer,
  action
) {
  switch (action.type) {
    case "SEARCH_USER_PROFILE_REQUEST":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
